<template>
  <div class="modal fade" id="voucherView">
    <div class="modal-dialog modal-xl">
    <div class="modal-content">
        <div class="modal-header bg-aqua">
        
        <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Voucher Details</h4>
        </div>
        <div class="modal-body">
        <!-- right column -->
        <div class="row">
            <div class="col-md-12">
            <!-- Profile Image -->
            <div class="card card-primary card-outline">
                <div class="card-body box-profile">
                <table class="table table-sm table-bordered table-striped table-hover">
                    <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Voucher No</th>
                        <th>Date</th>
                        <th>Dr</th>
                        <th>Cr</th>

                        <!-- <th v-if="$gate.isAdmin()">Status</th>
                        <th>Image</th>
                        <th v-if="$gate.isAdmin()">Modify</th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(ventry, index) in ventries" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ ventry.voucherNo }}</td>
                        <td>{{ ventry.date }}</td>
                        <td>
                        <span v-for="(dr, id) in ventry.dr_ledger" :key="id">
                            {{dr.amt}}<br>
                        </span>
                        </td>
                        <td>
                        <span v-for="(cr, id) in ventry.cr_ledger" :key="id">
                            {{cr.amt}}<br>
                        </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card -->
            </div>
        </div>
        </div>
        <div class="modal-footer text-center">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
        >
            CLOSE
        </button>
        </div>
    </div>
    <!-- /.modal-content -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'emivoucherentry',
  props: ['ventries']
}
</script>



// WEBPACK FOOTER //
// EmiVoucherEntry.vue?d7eaf278